import { getEnv, isRoot, getRoot } from 'mobx-state-tree';

import { showError, showInfo, showSuccess } from '@components/toaster';

export const withEnv = (instance) => {
  const env = getEnv(instance);

  if (isRoot(instance)) {
    return {
      get env() {
        return env;
      },
    };
  }

  const root = getRoot(instance);
  return {
    get env() {
      return {
        t: env.t,
        lang: env.lang,
        showSuccess: showSuccess,
        showError: showError,
        showInfo: showInfo,
        theme: env.theme,
        router: env.router,

        current: root,
        company: root,
        api: root.api,
        jobStore: root.jobs,
        userStore: root.users,
        applicationStore: root.applications,
      };
    },
  };
};
